import { useEffect, useState } from 'react';
import LogoRef from '../../../assets/img/logoRef.png';
import { ServerRequestProtected, ServerRequestPublic } from '../../../utils/ServerDataRequest';
import { enumUtil } from '../../../utils/Enum';
import DropdownValueHandler from '../../shared/SuperSearch/DropdownValueHandler';
import FormatPhoneNumber from '../../../utils/FormatPhoneNumber';
import States, { EmploymentStatus, GenderDemographic, GenderIdentity, MaritalStatus } from '../../../utils/Constants';
import isNull from '../../../utils/NullChecking';
import SignEncounter from '../../Patient/PatientDetails/Encounter/Components/EncounterRightPortion/TemplateView/Components/SignEncounter';
import handleNumericCheck from '../../../utils/HandleNumericKeys';
import FormValidator from '../../../utils/FormValidator';
import NotificationHandler from '../../../utils/NotificationHandler';
import Loader from '../../shared/Loader/Loader';
import { formatFax } from '../../../utils/Formatting';
const ReleaseOfInformation = ({ ID, InsuranceDD, PracticeInfo, PatientName, IsSubmitted, isDeleted, IsDefaultSignature, DefaultSignaturePath }) => {
    let Demographics_Modal = {
        PatientIntakeFormID: "",
        RecipientTo: "",
        RecipientAddress: "",
        RecipientState: "",
        RecipientCity: "",
        RecipientZipCode: "",
        OTP: "",
        SignaturePath: "",
        CompleteMedicalRecord: false,
        AlcoholDrugTreatment: false

    }
    let valModal = {}
    let ValidationModal = {
        SignaturePath: "",
        OTP: "",
        CompleteMedicalRecord: "",
    }
    const [validationErrors, setValidationErrors] = useState(ValidationModal)
    const [isSign, setIsSign] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const API_URL_Intake = enumUtil.controller.PATIENT
    const [patientFormData, setPatientFormData] = useState(Demographics_Modal)
    const [isFormSubmitted, setIsFormSubmitted] = useState(IsSubmitted === "true" ? true : false);
    const [isFormSaved, setIsFormSaved] = useState(false);
    const [savePatientFormData, setSavePatientFormData] = useState({})
    const [hasDefaultSignature, setHasDefaultSignature] = useState(IsDefaultSignature);
    const handleChangeField = (e) => {
        let { name, value } = e.target;
        let modal = { ...patientFormData };
        let saveModal = { ...savePatientFormData }

        if (name === "CompleteMedicalRecord" || name === 'AlcoholDrugTreatment') {
            modal[name] = !modal[name]
        } else {
            modal[name] = value;
        }
        setPatientFormData(modal)
        for (var property in Demographics_Modal) {
            if (name === property) {
                if (name === "CompleteMedicalRecord" || name === 'AlcoholDrugTreatment') {
                    saveModal[name] = modal[name] + ""
                } else {
                    saveModal[name] = value
                }
            }
        }
        setSavePatientFormData(saveModal)
    }
    useEffect(() => {
        if (isDeleted === 'true') {
            NotificationHandler("This form has been deleted.", enumUtil.enumtoaster.error);
            return
        }
        ServerRequestProtected(API_URL_Intake + "/PatientData", 'post', {
            'TableName': enumUtil.enumAPITableName.PatientIntakeTemplateData,
            "Value": ID
        }).then((response) => {
            setIsLoading(false)
            setSavePatientFormData(response)
            let data = { ...response }
            data.State = DropdownValueHandler(States, response.State)
            data.Sex = DropdownValueHandler(GenderDemographic, response.Sex)
            data.GenderIdentity = DropdownValueHandler(GenderIdentity, response.GenderIdentity)
            data.MaritalStatus = DropdownValueHandler(MaritalStatus, response.MaritalStatus)
            data.EmploymentStatus = DropdownValueHandler(EmploymentStatus, response.EmploymentStatus)
            if (!isNull(data.CellPhone)) {
                data.CellPhone = FormatPhoneNumber(data.CellPhone)
            }
            if (!isNull(data.HomePhone)) {
                data.HomePhone = FormatPhoneNumber(data.HomePhone)
            }
            if (!isNull(data.WorkPhone)) {
                data.WorkPhone = FormatPhoneNumber(data.WorkPhone)
            }
            if (!isNull(data.OtherPhone)) {
                data.OtherPhone = FormatPhoneNumber(data.OtherPhone)
            }
            const mappedData = {
                ...Demographics_Modal,
                ...data,
            }
            setPatientFormData(mappedData)
        }).catch((error) => {
            setIsLoading(false)
            const initialData = {
                ...Demographics_Modal,
            }
            setPatientFormData(initialData)
            setSavePatientFormData(initialData)
        })
    }, [])
    const clearForm = () => {
        const clearedData = {
            ...Demographics_Modal,
            PatientIntakeFormID: '0'
        }
        setPatientFormData(clearedData)
        setSavePatientFormData(clearedData)
        setValidationErrors({})
    }
    const getSaveData = async (_, filename, base64, obj) => {
        let newData = {
            "SignatureFileName": filename,
            "SignaturePath": base64,
            "IsDefaultSignature": obj?.isDefaultSignature.toString()
        }
        setPatientFormData(prev => ({ ...prev, ...newData }))
        setSavePatientFormData(prev => ({ ...prev, ...newData }))
    }
    const handleRemoveFile = () => {
        let newData = {
            "SignatureFileName": '',
            "SignaturePath": ''
        }
        setHasDefaultSignature('false')
        setPatientFormData(prev => ({ ...prev, ...newData }))
        setSavePatientFormData(prev => ({ ...prev, ...newData }))
    }
    const ROIValidation = async () => {
        const isSignatureValid = patientFormData.SignaturePath || (hasDefaultSignature === 'true' && DefaultSignaturePath);

        let ValidationModal = {
            OTP: FormValidator(
                patientFormData.OTP,
                enumUtil.enumValidationType.Required,
                'OTP',
            ),
            SignaturePath: isSignatureValid ? '' : FormValidator(
                patientFormData.SignaturePath,
                enumUtil.enumValidationType.Required,
                'Signature',
            ),
            CompleteMedicalRecord: FormValidator(
                patientFormData.CompleteMedicalRecord,
                'Bool',
                'Information to be Released',
            ),
        }
        await setValidationErrors(ValidationModal)
        valModal = ValidationModal
    }
    const handleSubmitROI = async () => {
        await ROIValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            setIsLoading(true)

            let DefualtSignatureData = {};

            if (hasDefaultSignature === 'true') {
                DefualtSignatureData = {
                    'IsDefaultSignature': hasDefaultSignature,
                    'SignaturePath': DefaultSignaturePath
                };
            } else {
                DefualtSignatureData = {
                    'SignatureFileName': savePatientFormData.SignatureFileName ? savePatientFormData.SignatureFileName : '',
                    'SignaturePath': savePatientFormData.SignaturePath ? savePatientFormData.SignaturePath : '',
                    'IsDefaultSignature': savePatientFormData.IsDefaultSignature ? savePatientFormData.IsDefaultSignature : '',
                };
            }

            const saveData = {
                TableName: enumUtil.enumAPITableName.ReleaseOfInformationForm,
                // ID: 0, // For new records, 0 for create
                DATA: {
                    PatientIntakeFormID: '0',
                    GuidID: ID,
                    PatientID: savePatientFormData.PatientID + "",
                    RecipientTo: '',
                    RecipientAddress: ' 8009 Savannah Rd, Katerpiller Lane Street Sanersvile',
                    RecipientState: 'GA',
                    RecipientCity: 'Sanersvile',
                    RecipientZipCode: '13082',
                    CompleteMedicalRecord: savePatientFormData.CompleteMedicalRecord,
                    AlcoholDrugTreatment: savePatientFormData.AlcoholDrugTreatment,
                    OTP: savePatientFormData.OTP,
                    ...DefualtSignatureData,
                }
            }
            ServerRequestProtected(API_URL_Intake + "/SaveROIForm", 'post', saveData)
                .then((response) => {
                    setIsLoading(false)
                    NotificationHandler("Form submitted successfully", enumUtil.enumtoaster.success)
                    setIsFormSubmitted(true)
                    setIsFormSaved(true)
                }).catch((error) => {
                    setIsLoading(false)
                    setIsFormSubmitted(false)
                    setIsFormSaved(false)
                    NotificationHandler(error.response?.data || "Error submitting form", enumUtil.enumtoaster.error)
                })
        }

    }

    const [isSignImage, setIsSignImage] = useState(false);
    const loadSignatureFromServer = async (path) => {
        try {
            const response = await ServerRequestPublic(
                enumUtil.controller.Wasabi + "/DownloadFile",
                "post",
                { BucketPath: path },
                "Download"
            );

            if (
                response.type === "application/png" ||
                response.type === "application/jpg" ||
                response.type === "application/jpeg"
            ) {
                setIsSignImage(URL.createObjectURL(response));
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if (hasDefaultSignature === 'true' && DefaultSignaturePath) {
            loadSignatureFromServer(DefaultSignaturePath);
        }
    }, [hasDefaultSignature === 'true', DefaultSignaturePath]);

    return (
        <>
            {isDeleted === 'true' ? null :
                <div className='ar_pat-info-form-fill d-flex justify-content-center'>
                    {isLoading ? <Loader /> : null}
                    {isFormSubmitted ?
                        <div className="ar_fill-content-box d-flex flex-column">
                            <div className="d-flex align-items-center justify-content-between bg-white br-bottom-1 za_br_light pb-1-5 practice-info">
                                <div className="">
                                    <img src={LogoRef} alt="" style={{ maxHeight: '55px' }} crossOrigin="anonymous" />
                                </div>
                                <div className="text-center">
                                    <p className='heading text-black fs-16'>{PracticeInfo?.PracticeName}</p>

                                    <p className="text text-black fs-14"> {PracticeInfo?.PracticeAddress} <br />
                                        {PracticeInfo?.PracticeCity} ,  {PracticeInfo?.PracticeState},  {PracticeInfo?.PracticeZipCode}</p>

                                </div>
                                <div className="d-flex gap-10">
                                    <div className="">
                                        <p className='text text-black font-m fs-14 pb-2px'>Tel:</p>
                                        <p className='text text-black font-m fs-14'>Fax:</p>
                                    </div>
                                    <div className="">
                                        <p className='text text-black  pb-2px fs-14'>{FormatPhoneNumber(PracticeInfo?.PracticeTelephone)}</p>
                                        {/* <p className='text text-black fs-14'>{PracticeInfo?.PracticeFax}</p> */}
                                        <p className='text text-black fs-14'>{formatFax(PracticeInfo?.PracticeFax)}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="bg-white">
                                <p className="heading fs-16 lh-17 text-white form-heading">Release of Information</p>
                                {/* <p className="text fs-12 lh-14 form-instruction p-2">Please fill out all fields as accurately as possible. This information helps us provide you with the best care. If you need any assistance with completing this form, please don't hesitate to contact us.</p> */}
                            </div>
                            <div className='sucsses_meessage d-flex align-items-center gap-20'>
                                <div>
                                    <i className='icon-tick-mark fs-49'></i>
                                </div>
                                <div >
                                    <p className='fs-22 text font-m green_Color'>
                                        {isFormSaved ? 'Form Submission Successful!' : 'This form is already submitted!'}
                                    </p>
                                    <p className='text fs-14'>Thank you for submitting the form. If you need further assistance, feel free to contact us.</p>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="ar_fill-content-box d-flex flex-column gap-16">
                            <div className="d-flex align-items-center justify-content-between bg-white br-bottom-1 za_br_light pb-1-5 practice-info">
                                <div className="">
                                    <img src={LogoRef} alt="" style={{ maxHeight: '55px' }} crossOrigin="anonymous" />
                                </div>
                                <div className="text-center">
                                    <p className='heading text-black fs-16'>{PracticeInfo?.PracticeName}</p>

                                    <p className="text text-black fs-14"> {PracticeInfo?.PracticeAddress} <br />
                                        {PracticeInfo?.PracticeCity} ,  {PracticeInfo?.PracticeState},  {PracticeInfo?.PracticeZipCode}
                                    </p>

                                </div>
                                <div className="d-flex gap-10">
                                    <div className="">
                                        <p className='text text-black font-m fs-14 pb-2px'>Tel:</p>
                                        <p className='text text-black font-m fs-14'>Fax:</p>
                                    </div>
                                    <div className="">
                                        <p className='text text-black  pb-2px fs-14'>{FormatPhoneNumber(PracticeInfo?.PracticeTelephone)}</p>
                                        {/* <p className='text text-black fs-14'>{PracticeInfo?.PracticeFax}</p> */}
                                        <p className='text text-black fs-14'>{formatFax(PracticeInfo?.PracticeFax)}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="bg-white">
                                <p className="heading fs-16 lh-17 text-white form-heading">Release of Information</p>
                                <p className="text fs-12 lh-14 form-instruction p-2">Please fill out all fields as accurately as possible. This information helps us provide you with the best care. If you need any assistance with completing this form, please don't hesitate to contact us.</p>
                            </div>
                            <div className="ar_star-form-Preview">
                                <div className="Form-content d-flex flex-column gap-16 pe-1 hover-scrollbar ar-Roi-fill-form">
                                    <div className="">
                                        <div className="pateint-information mb-10">
                                            <div className="d-flex align-items-center gap-1">
                                                <p className="heading fs-14 text-black min-w-72px">{patientFormData.LastName + ', ' + patientFormData.FirstName}</p>
                                                <p className='text fs-13 text-black'>{patientFormData.DOB}</p>
                                                {/* <p className='text fs-13 text-black'>(34 Y)</p> */}
                                                <p className='text fs-13 text-black'>{patientFormData.Sex}</p>
                                            </div>
                                            <div className="d-flex align-items-center gap-1">
                                                <p className="heading fs-13 font-m text-black min-w-72px">Phone: </p>
                                                <p className='text fs-13 text-black'>{patientFormData.CellPhone ? patientFormData.CellPhone : 'N/A'}</p>
                                            </div>
                                            <div className="d-flex  gap-1">
                                                <p className="heading fs-13 font-m text-black min-w-72px">Address:</p>
                                                <p className='text fs-13 text-black'>
                                                    {patientFormData.Address1 ? patientFormData.Address1 : 'N/A'}
                                                    {[patientFormData?.City, patientFormData?.State, patientFormData?.ZipCode]
                                                        .filter(Boolean)
                                                        .join(', ')}
                                                </p>
                                            </div>
                                        </div>
                                        <p className="text text-black fs-13">I, authorize health care provider or practice mentioned in item 2 to use or disclose following information mentioned in item 5 to the above named patient:</p>
                                    </div>

                                    <div className="">
                                        <p className="heading text-black fs-14 mb-1">2. Healthcare Provider/Practice (Information Holder)</p>
                                        <p className='text text-black'>{PracticeInfo?.PracticeName}</p>
                                        <p className="text text-black"> <span className="font-m">Address:</span>
                                            {PracticeInfo?.PracticeAddress} <br />
                                            {[PracticeInfo?.PracticeCity, PracticeInfo?.PracticeState, PracticeInfo?.PracticeZipCode]
                                                .filter(Boolean)
                                                .join(', ')}</p>
                                    </div>

                                    <div className="">
                                        <p className="heading text-black fs-14 mb-1">3. Recipient (To Whom Information will be Shared)</p>
                                        <p className='text text-black'>NORTHWEST FLORIDA</p>
                                        <p className="text text-black"> <span className="font-m">Address:</span> 8009 Savannah Rd, Katerpiller Lane Street <br /> Sanersvile, GA, 13082</p>
                                    </div>

                                    <div className="">
                                        <p className="heading text-black fs-14 mb-1">4. Purpose of Disclosure</p>
                                        <p className='text text-black'>The information may be shared to support your care, treatment, or billing needs. It may also be used for legal, insurance, or personal purposes as requested.</p>
                                    </div>

                                    <div className="old-validation-design d-flex flex-column gap-1">
                                        <p className="heading text-black fs-14">5. Information to be Released <span className="text font-m Denied-clr fs-14">*</span>  </p>
                                        <div className="custom_check_box d-flex gap-6">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0 mt-3px"
                                                name='CompleteMedicalRecord'
                                                id='CompleteMedicalRecord'
                                                checked={patientFormData.CompleteMedicalRecord || false}
                                                onChange={handleChangeField}
                                            />
                                            <div className="">
                                                <p className="text fs-12 text-black user-select-none">Complete Medical Record, including:</p>
                                                <p className="text fs-12 text-black ar_dot">Patient Histories</p>
                                                <p className="text fs-12 text-black ar_dot">Lab Results</p>
                                                <p className="text fs-12 text-black ar_dot">Radiology Studies/FilmsReferrals</p>
                                                <p className="text fs-12 text-black ar_dot">Consults</p>
                                                <p className="text fs-12 text-black ar_dot">Patient Histories</p>
                                                <p className="text fs-12 text-black ar_dot">Billing RecordsInsurance Records</p>
                                                <p className="text fs-12 text-black ar_dot">Other</p>
                                            </div>
                                        </div>

                                        {validationErrors.CompleteMedicalRecord && <div className="input error">{validationErrors.CompleteMedicalRecord}</div>}
                                        <div className="custom_check_box d-flex align-items-center gap-6">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                name='AlcoholDrugTreatment'
                                                id='AlcoholDrugTreatment'
                                                checked={patientFormData.AlcoholDrugTreatment || false}
                                                onChange={handleChangeField}
                                            />
                                            <p className="text fs-12 text-black user-select-none">Alcohol/Drug Treatment, Mental Health Information and HIV-Related Information.</p>
                                        </div>
                                    </div>

                                    <div className="">
                                        <p className="heading text-black fs-14 mb-1">6. Patient Rights/Authorization</p>
                                        <div className="d-flex flex-column gap-1 ps-2">
                                            <p className="text fs-12 text-black ar_dot">I may revoke this authorization at any time by contacting to the healthcare provider listed above.</p>
                                            <p className="text fs-12 text-black ar_dot">I understand that I cannot revoke this authorization for information that has already been released.</p>
                                            <p className="text fs-12 text-black ar_dot">Information disclosed under this authorization might be redisclosed by the recipient, and this redisclosure may no longer be protected by federal or state law.</p>
                                        </div>
                                    </div>

                                    <div className="">
                                        <p className="heading text-black fs-14 mb-1">7. Expiration/Revocation</p>

                                        <div className="">
                                            <p className="text fs-12 text-black">This authorization will remain in effect until it is revoked by contacting the practice.</p>
                                            <p className="text fs-12 text-black ar_dot ps-2">
                                                I understand that I can revoke this authorization at any time prior to that date. Revocation will not apply to information that has already been released based on this authorization.</p>
                                        </div>
                                    </div>

                                    <div className="">
                                        <p className="heading text-black fs-14 mb-1">8. Signature Authorization</p>

                                        <div className="d-flex flex-column gap-5">
                                            <p className="text fs-12 text-black">I consent that my electronic signature below has the same legal effect as a handwritten signature for purposes of validity.</p>
                                            <div className="content-box d-flex gap-10">
                                                <p className='text fs-14 text-black min-w-156px d-flex align-items-center justify-content-end gap-01'>
                                                    Patient Signature<span className="text font-m Denied-clr fs-14">*</span>
                                                </p>
                                                {!isNull(patientFormData.SignaturePath) || hasDefaultSignature === 'true' ?
                                                    <div className="position-relative sign-here-box provider-sign-box cursor-pointer d-flex align-items-center justify-content-center h-100 py-4 px-2 w-100">
                                                        <div className="d-flex gap-10 align-items-center">
                                                            <div className="">
                                                                <img
                                                                    src={hasDefaultSignature === 'true' ? isSignImage : `data:image/png;base64,${patientFormData.SignaturePath}`}
                                                                    alt="Patient Signature"
                                                                    style={{ maxHeight: '81px' }}
                                                                />
                                                                <span className="cross-icon d-flex" onClick={handleRemoveFile}>
                                                                    <i className="icon-x-cros fs-14 dark-clr fw-900"></i>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div> :
                                                    <div className={`input w-100 ${validationErrors.SignaturePath ? 'error' : ''}`}>
                                                        <div className={`form-control cursor-pointer d-flex align-items-center`} onClick={() => setIsSign(true)}>
                                                            <p className="text color-7070 select-none">
                                                                {patientFormData.SignatureFileName || 'Click to sign here'}
                                                            </p>
                                                        </div>
                                                        {validationErrors.SignaturePath && <div className="">{validationErrors.SignaturePath}</div>}
                                                    </div>
                                                }
                                            </div>
                                            <div className="">
                                                <div className='ar_OTP-section d-flex flex-column gap-10'>
                                                    <p className='Patient-Payment text fs-13 ar_text w-max-content'>We've sent a verification code to your email. Check the same email you used to open the intake form link.</p>
                                                    <div className='px-2  content-box'>
                                                        <p className='text font-m ar-light-color fs-13 pb-3px'>Enter OTP here</p>
                                                        <div className={`input mb-0 w-50 ${validationErrors.SignaturePath ? 'error' : ''}`}>
                                                            <input
                                                                type="text"
                                                                className="form-control h-28 za_br_light"
                                                                name="OTP"
                                                                id="OTP"
                                                                autoComplete="off"
                                                                onChange={handleChangeField}
                                                                value={patientFormData.OTP || ''}
                                                                onKeyPress={(event) => handleNumericCheck(event)}
                                                            />
                                                            {validationErrors.OTP && <div className="">{validationErrors.OTP}</div>}
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <SignEncounter
                                        isSign={isSign}
                                        setIsSign={setIsSign}
                                        setSearchParam={() => { }}
                                        providerName={PatientName}
                                        isOpenedFrom={'PatientDefaultSignature'}
                                        getSaveData={getSaveData}
                                    />
                                    <div className='d-flex justify-content-between align-items-center footer-btn px-10'>
                                        <button className='btn btn-orange h-auto submit-btn fs-14 font-sb' onClick={handleSubmitROI}>Submit Form</button>
                                        <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={clearForm}>Clear Form</button>
                                    </div>
                                    {/* <div className="">
                            <div className='ar_OTP-section d-flex flex-column gap-10'>
                                <p className='Patient-Payment text fs-13 ar_text w-max-content'>We've sent a verification code to your email. Check the same email you used to open the intake form link.</p>
                                <div className='px-2  content-box'>
                                    <p className='text font-m ar-light-color fs-13 pb-3px'>Enter OTP here</p>
                                    <div className={`input mb-0 w-50 `}>
                                        <input
                                            type="text"
                                            className="form-control h-28 za_br_light"
                                            name="OTP"
                                            id="OTP"
                                            autoComplete="off"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='d-flex justify-content-between align-items-center footer-btn px-10'>
                                <button className='btn btn-orange h-auto submit-btn fs-14 font-sb' >Submit Form</button>
                                <button className='btn btn-outline  px-10 h-100 dark-clr'>Clear Form</button>
                            </div>
                        </div> */}
                                </div>
                            </div>
                        </div>
                    }
                </div>
            }
        </>
    )
}

export default ReleaseOfInformation